
import {
    defineComponent,
    onMounted,
    watch,
    ref,
    toRef,
    reactive
} from "vue";

import {
    CigoAdminStore
} from "@/components/cigo-admin-core/store";
import {
    TweenMax
} from "gsap";

export default defineComponent({
    name: "LogoArea",
    setup() {
        let Env = reactive(process.env);
        let menuOpenFlag = toRef(
            CigoAdminStore.getState().systemState,
            "sideMenuOpen"
        );
        watch(menuOpenFlag, (openFlag: boolean, preOpenFLag: boolean) => {
            menuChange(openFlag);
        });

        onMounted(() => {
            menuChange(menuOpenFlag.value);
        });

        const menuChange = (openFlag: boolean) => {
            /** 隐藏者立即执行，显示者延迟200ms，以便隐藏到一定程度才显示 */
            /** 因为显示周期长于隐藏周期 */
            TweenMax.to(".short-title", openFlag ? 0.5 : 0.8, {
                opacity: openFlag ? 0 : 1,
                delay: openFlag ? 0 : 0.2
            });
            TweenMax.to(".full-title", openFlag ? 0.8 : 0.5, {
                opacity: openFlag ? 1 : 0,
                width: openFlag ? "182px" : "0px",
                delay: openFlag ? 0.2 : 0
            });
        };

        return {
            Env
        }
    }
});
